import axios, { isAxiosError } from 'axios';

const getCloudEntryByComponentEntryId = async componentEntryId => {
  if (!componentEntryId) {
    return {
      googleDrive: undefined,
      oneDrive: undefined
    };
  }
  try {
    const url = `${process.env["NEXT_PUBLIC__USERDATA_API"]}/api/CloudEntries?entryID=${encodeURIComponent(componentEntryId)}`;
    const response = await axios.get(url);
    if (response.status === 204) {
      return {};
    }
    return {
      googleDrive: response.data.googleDrive?.uri !== undefined ? {
        fileId: response.data.googleDrive.uri,
        modifiedAt: new Date(response.data.googleDrive.modified * 1000)
      } : undefined,
      oneDrive: response.data.oneDrive?.uri !== undefined ? {
        fileId: response.data.oneDrive.uri,
        modifiedAt: new Date(response.data.oneDrive.modified * 1000)
      } : undefined
    };
  } catch (err) {
    if (isAxiosError(err) && err.response?.status === 404) {
      return {};
    }
    throw err;
  }
};

export { getCloudEntryByComponentEntryId };
//# sourceMappingURL=request.get-cloud-entries.js.map
